<template>
  <zm-form
    ref="addressForm"
    :rules="rules"
    :model="form"
    label-position="inline"
    class="opc-payment__addr"
    :disabled="disabled"
  >
    <address-base-form :form="form" affix="bill-to"/>
  </zm-form>
</template>

<script type="text/jsx">
import formMixins from "../contact-info/mixins/form-mixin";
import AddressBaseForm from "../contact-info/address-base-form.vue";

export default {
  components: {AddressBaseForm},
  mixins: [formMixins],
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    disabled:{
      type: Boolean,
      default: false,
    }
  },
  methods: {
    async validate() {
      return this.$refs.addressForm?.validate();
    },
  },
}
</script>

<style lang="scss">
@import "../../styles/common";

.opc-payment {
  &__addr {
    margin-top: 16px;
    @extend .checkout-form;
    .zm-button--plain:not(.is-ghost) {
        border: none;
    }
  }
}
</style>
